<!--
 * @Author: xiehangyi
 * @LastEditors: xiehangyi
 * @Description: svg-icon
-->
<template>
  <svg
    aria-hidden="true"
    class="lc-svg-icon"
  >
    <use :xlink:href="icon" />
  </svg>
</template>

<script>
export default {
  name: 'LcSvgIcon',
  props: {
    iconClass: {
      type: String,
      default: 'materials_svg'
    },
  },
  computed: {
    icon() {
      return `#lc_${this.iconClass}`
    },
  },
}
</script>
